import request from '../utils/request'
import qs from 'qs'
import { MessageBox } from 'element-ui';
import {processSign} from './bjcalib'
import context from '../main'



var random = "";
var callback = null

export async function certificatesignauthen(randomNumber, certsigner,back) {
  random = randomNumber

  callback = back
  const signData = await processSign(randomNumber,context)
  if(!signData){
    return
  }
  buttonAttachedSign_Succeed(0,signData)
}




export function buttonAttachedSign_Succeed(errorCode,signedData){//普通Key Attached签名  成功后数据处理

  if (errorCode != 0){
    swalShowIe("消息提示", errorCode, "warning");
  }else{
    request({
      method:'post',
      url:'/ssoserver/login/comeinSs',
      headers:{
        'Content-Type':'application/x-www-form-urlencoded'
      },
      data:qs.stringify({appId:process.env.APP_ID,randomNumber:random,sign_value:signedData,action:'login',auth:'9;0;3',signfield:'cn',personfield:'uid',logintype:'2'})
    }).then(result=>{
      if(!!callback){
        callback(result)
      }
    }).catch(msg=>{
      swalShowIe("提示", msg, "error");
    })
    //document.getElementsByName("randomNumber")[0].value = random;
    //document.getElementsByName("sign_value")[0].value = signedData;
    //document.getElementsByName("login_form")[0].submit()
  }
}

export function swalShowIe(title, text, status) {
  try {
    swal({
      title : title,
      text : 	text,
      type : "error"
    });
  } catch (e) {
    alert("   "+text+"   ");
  }

}

export function ukConfig() {

  return true
}



// WEBPACK FOOTER //
// ./src/js/caLogin.js